import React, { Component } from "react";
import { Button, Notice, NOTICE_TYPES } from "@appcues/component-library";
import styled from "styled-components";
import AutosuggestProfileAttribute from "components/Common/AutosuggestProfileAttribute";
import {
  checkIsBlank,
  checkHasProtocol,
  checkIsDuplicate
} from "utils/validation";
import { errorMessages } from "constants/urlInput";

class AddUrlStep extends Component {
  state = {
    error: null,
    input: ""
  };

  handleInputChange = value => {
    this.setState({ input: value });
  };

  handleHotkeyPress = (event, highlightedIndex, closeMenu) => {
    const { handleSubmit } = this.props;
    const { input } = this.state;

    if (event.key === "Enter" && highlightedIndex === null) {
      if (this.validateInput(input)) {
        handleSubmit(input);
        this.setState({ input: "", error: null }, closeMenu);
      } else {
        closeMenu();
      }
    }
  };

  handleAddUrl = () => {
    const { handleSubmit } = this.props;
    const { input } = this.state;

    if (this.validateInput(input)) {
      handleSubmit(input);
      this.setState({ input: "", error: null });
    }
  };

  validateInput = input => {
    const { testUrls } = this.props;

    const blank = checkIsBlank(input);
    const duplicate = checkIsDuplicate(input, testUrls);
    const hasProtocol = checkHasProtocol(input);

    if (blank) {
      this.setState({ error: errorMessages.BLANK });
    } else if (duplicate) {
      this.setState({ error: errorMessages.DUPLICATE });
    } else if (!hasProtocol) {
      this.setState({ error: errorMessages.NOPROTOCOL });
    }

    return !blank && !duplicate && hasProtocol;
  };

  render() {
    const { className } = this.props;
    const { error, input } = this.state;

    return (
      <div className={className}>
        <div className="input-wrapper">
          <AutosuggestProfileAttribute
            value={input}
            property="_lastPageUrl"
            onChange={this.handleInputChange}
            onKeyDown={this.handleHotkeyPress}
          />
          <Button className="button-success" onClick={this.handleAddUrl}>
            Test
          </Button>
        </div>
        <div className="error-wrapper">
          {error && <Notice type={NOTICE_TYPES.warning}>{error}</Notice>}
        </div>
      </div>
    );
  }
}

export default styled(AddUrlStep)`
  .input-wrapper {
    display: flex;
    max-width: 700px;

    div {
      width: 98%;
    }

    .suggestion {
      width: 100%;
    }
  }

  .error-wrapper {
    max-width: 700px;
  }
`;
